// Shared formatters for Investment Plan fields. Money/ROI/duration fields
// can arrive as either numbers or numeric strings (see investmentPlansApi's
// normalizePlan comment) — every formatter here runs Number() first so it
// never chokes on either shape.

export function formatCurrency(value) {
  const num = Number(value);
  if (!Number.isFinite(num)) return '—';
  return `₦${num.toLocaleString(undefined, { maximumFractionDigits: 2 })}`;
}

export function formatDuration(days) {
  const num = Number(days);
  if (!Number.isFinite(num)) return '—';
  return `${num.toLocaleString()} day${num === 1 ? '' : 's'}`;
}

export function formatRoi(pct) {
  const num = Number(pct);
  if (!Number.isFinite(num)) return '—';
  return `${num}%`;
}

// For fields that only ship a `_minor` integer with no decimal-string
// sibling (e.g. PayoutSummary's outstanding_interest_minor) — converts from
// minor units (kobo) to major (naira) at the display layer only. Never used
// to derive a value that should instead come from the backend as a decimal
// string.
export function formatMinorCurrency(minor) {
  const num = Number(minor);
  if (!Number.isFinite(num)) return '—';
  return formatCurrency(num / 100);
}
